<script setup>
</script>

<template>
  <!-- Menu ends -->
  <div id="app">
    <!-- Menu starts here -->
    <Slide
      :close-on-navigation="true"
      style="margin-bottom: -24px;font-size: 120px"
      @openMenu="handleMenuOpen"
      @closeMenu="handleMenuClose"
    >
      <router-link to="/">
        <img
          src="./assets/svg/house.svg"
          alt="Husikon"
        ><span>Hem</span>
      </router-link>
      <router-link to="/news">
        <img
          src="./assets/svg/newspaper.svg"
          alt="Nyhetstidningsikon"
        ><span>Nyheter</span>
      </router-link>
      <router-link to="/about">
        <img
          src="./assets/svg/people.svg"
          alt="Personikon"
        ><span>Om oss</span>
      </router-link>
      <router-link to="/api_info">
        <img
          src="./assets/svg/code.svg"
          alt="</>"
        ><span>Öppen API</span>
      </router-link>
    </Slide>
    <!-- Depends on our route -->
    <router-view />
    <!-- Footer -->
    <footer class="footer-mar">
      <p>Några immateriella rättigheter finns nog</p>
      <p>
        Kontakt: <a
          href="mailto:kontakt@apkollen.se"
          style="color:darkorange"
        >kontakt@apkollen.se</a>
      </p>
      <p>
        Tack till <a
          href="https://www.instagram.com/lukaslenander/"
          style="color:darkorange"
        >@lukaslenander</a> för hjälp med loggan!
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    handleMenuOpen() {
      // We want to hide the button, for all our mobile friends
      const elements = document.getElementsByClassName("bm-burger-button");

      for (let i = 0; i < elements.length; i++) {
        elements[i].style.visibility = "hidden";
      }
    },
    handleMenuClose() {
      // Show it again
      const elements = document.getElementsByClassName("bm-burger-button");

      for (let i = 0; i < elements.length; i++) {
        elements[i].style.visibility = "visible";
      }
    },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.footer-mar {
  font-size: 90%;
  margin-bottom: 25px;
  line-height: 10px;
}
</style>
